import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'govuk-react-jsx';
import { useSelector } from 'react-redux';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import {
  getCompanyData,
  getBusinessVatData,
} from '../../features/registration/registrationJourneySlice';
import { getUserDetails } from '../../features/dashboard/dashboardSlice';
import { completePMCCLientRegistration } from '../../firebase';
import {
  getPMCData,
  getPmcLandlordType,
  getPmcLinkedEnterprise,
} from '../../features/pmc/pmcJourneySlice';
import useTitle from '../../hooks/useTitle';

const Declaration = () => {
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);

  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;
  const isLinkedEnterprise = useSelector(getPmcLinkedEnterprise);
  const companyDataRedux = useSelector(getCompanyData);
  const businessVatDataRedux = useSelector(getBusinessVatData);
  const currentUserData = useSelector(getUserDetails);
  const pmcClientData = useSelector(getPMCData);
  const selectedLandlordClient = useSelector(getPmcLandlordType);

  const history = useHistory();

  useTitle(
    'pmcClientReg.PMCDeclaration.s10',
    'Declaration - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );

  const handleBtnClick = () => {
    completePMCCLientRegistration({
      isLinkedEnterprise: isLinkedEnterprise === 'Yes',
      businessName: pmcClientData?.businessName,
      companyRegNumber: pmcClientData?.companyRegNumber
        ? pmcClientData?.companyRegNumber
        : '',
      businessNameUpper: pmcClientData?.businessNameUpper,
      businessAddressLine1: pmcClientData?.businessAddressLine1,
      businessAddressLine2: pmcClientData?.businessAddressLine2,
      businessAddressCity: pmcClientData?.businessAddressCity,
      businessAddressCounty: pmcClientData?.businessAddressCounty,
      businessAddressPostcode: pmcClientData?.businessAddressPostcode,
      businessAddressCountry: pmcClientData?.businessAddressCountry,
      landlordType: selectedLandlordClient,
      companyVatNumber: pmcClientData?.vatRegNumber
        ? pmcClientData?.vatRegNumber
        : '',
    })
      .then(() => {
        history.push('/pmcClientReg/client-registered');
      })
      .catch(() => {});
  };

  return (
    <>
      <span className="govuk-caption-xl">
        {companyDataRedux && companyDataRedux.company_name}
        {businessVatDataRedux &&
          businessVatDataRedux?.target &&
          businessVatDataRedux.target.name}
        {currentUserData != null &&
          currentUserData.business_name != null &&
          currentUserData.business_name}
      </span>
      <h1 className="govuk-heading-xl">
        {copyProvider.getCopy('pmcClientReg.PMCDeclaration.s1', 'Declaration')}
      </h1>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'pmcApp.PMCDeclaration.s2',
          'By continuing, you confirm that you:'
        )}
      </p>
      <ul className="govuk-list govuk-list--bullet">
        <li>
          {copyProvider.getCopy(
            'pmcApp.PMCDeclaration.s3',
            "understand the information provided and any supporting evidence will be used to assess your client's eligibility"
          )}
        </li>
        <li>
          {copyProvider.getCopy(
            'pmcApp.PMCDeclaration.s4',
            'will provide the correct information to the best of your knowledge'
          )}
        </li>
        <li>
          {copyProvider.getCopy(
            'pmcApp.PMCDeclaration.s5',
            'agree to be contacted by the Office for Zero Emission Vehicles (OZEV) or its agents for audit purposes'
          )}
        </li>
        <li>
          {copyProvider.getCopy(
            'pmcApp.PMCDeclaration.s6',
            "confirm that you have your client's consent to register and provide their business information"
          )}
        </li>
      </ul>
      <Button
        className="govuk-button-group govuk-!-margin-top-4"
        onClick={handleBtnClick}
      >
        {copyProvider.getCopy(
          'pmcApp.PMCDeclaration.s7',
          'Accept and continue'
        )}
      </Button>
    </>
  );
};

export default Declaration;
